import { render, staticRenderFns } from "./ModelSelectOption.vue?vue&type=template&id=1b3a4b6b&scoped=true&lang=pug&"
import script from "./ModelSelectOption.vue?vue&type=script&lang=js&"
export * from "./ModelSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./ModelSelectOption.vue?vue&type=style&index=0&id=1b3a4b6b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a4b6b",
  null
  
)

/* custom blocks */
import block0 from "./ModelSelectOption.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports